import { render } from "./semaforo.vue?vue&type=template&id=15b70a43"
import script from "./semaforo.vue?vue&type=script&lang=js"
export * from "./semaforo.vue?vue&type=script&lang=js"

import "./semaforo.vue?vue&type=style&index=0&id=15b70a43&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__